import type { AvatarProps } from './types';

export const composeUniqueKey: (props: AvatarProps, index: number) => string | number = (
	props: AvatarProps,
	index: number,
) => {
	if (props.key) {
		return props.key;
	}
	return index;
};
